import { __assign } from "tslib";
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import getContext from 'recompose/getContext';
import { get, assign, partial } from 'lodash-es';
import { HotspotType, OverlayPosition } from '@marvelapp/core';
import * as hotspotAction from '../constants/hotspotAction';
import * as screenLocation from '../constants/screenLocation';
import DumbHotspot from '../components/Hotspot';
import EmbeddedHotspot from '../components/EmbeddedHotspot';
import TouchableHotspot from '../components/TouchableHotspot';
import HoverHotspot from '../components/HoverHotspot';
import ExternalLinkHotspot from '../components/ExternalLinkHotspot';
import VideoHotspot from '../components/VideoHotspot';
import * as actionCreators from '../actionCreators';
import { getHotspotStyle, getScreenStyles } from '../selectors/layout';
import { getHotspotByID, areHotspotsVisible, staysInSection, } from '../selectors/hotspot';
import { getClickPosition } from '../utils/tracking';
import { getIsEnterprise, getRenderedScreenDimensions } from '../selectors';
import * as userTestUtils from '../utils/userTest';
import ScrollContainer from './ScrollContainer';
import FormFieldHotspot from '../components/FormFieldHotspot';
function mapStateToProps(state, _a) {
    var id = _a.id, isCurrentScreen = _a.isCurrentScreen, location = _a.location, screenID = _a.screenID;
    var hotspot = getHotspotByID(state, id);
    var _b = getScreenStyles(state, true), footerHeight = _b.footerHeight, headerHeight = _b.headerHeight;
    return __assign(__assign(__assign({}, hotspot), getHotspotStyle({ state: state, isCurrentScreen: isCurrentScreen, hotspot: hotspot, location: location, screenID: screenID })), { viewport: getRenderedScreenDimensions(state), footerHeight: footerHeight,
        headerHeight: headerHeight, isVisible: areHotspotsVisible(state), hasTouch: state.deviceDetection.hasTouch, currentScreenID: get(state, 'screen.currentScreen.id'), previousScreenID: get(state, 'screen.previousScreen.id'), currentOverlayID: get(state, 'screen.currentOverlayHotspot.id'), getClickPosition: partial(getClickPosition, state), getEventMeta: partial(userTestUtils.getEventMeta, state), staysInSection: staysInSection(state, id), isEnterprise: getIsEnterprise(state) });
}
function mergeProps(stateProps, _a, ownProps) {
    var dispatch = _a.dispatch;
    var boundHandleHotspotAction = function (eventMeta) {
        handleHotspotAction(dispatch, ownProps, stateProps, eventMeta);
    };
    var boundHandleHoverAction = function (coordinates, eventMeta) {
        handleHoverAction(dispatch, ownProps, stateProps, coordinates, eventMeta);
    };
    var newProps = {
        onClick: function (e) {
            e.stopPropagation();
            dispatch(actionCreators.click(stateProps.getClickPosition(stateProps.id, e)));
            boundHandleHotspotAction(stateProps.getEventMeta(e));
        },
        onTouch: function (e) {
            boundHandleHotspotAction(stateProps.getEventMeta(e));
        },
        hover: function (e, coordinates) {
            e.stopPropagation();
            boundHandleHoverAction(coordinates, stateProps.getEventMeta(e));
        },
    };
    return assign({}, ownProps, stateProps, newProps);
}
function handleHoverAction(dispatch, ownProps, stateProps, coordinates, eventMeta) {
    var currentOverlayID = stateProps.currentOverlayID, currentScreenID = stateProps.currentScreenID, destinationScreenID = stateProps.destinationScreenID, id = stateProps.id, isOverlay = stateProps.isOverlay, maintainScroll = stateProps.maintainScroll, stayOnTarget = stateProps.stayOnTarget, transition = stateProps.transition;
    var screenScrollPos = getScreenScrollPos(ownProps, stateProps);
    var actionMeta = __assign({ hotspotID: id, screenScrollPos: screenScrollPos }, eventMeta);
    if (isOverlay) {
        // TODO probably be easier if scroll was in state? But might be terrible
        // perf? (though updating scroll in state wouldn't re-render anything as no
        // component props depend on it?)
        var overlayScrollPos = getOverlayScrollPos(ownProps, stateProps);
        if (!stayOnTarget) {
            dispatch(actionCreators.showHoverOverlay(id, overlayScrollPos, actionMeta));
        }
        else {
            dispatch(actionCreators.showOverlay(id, overlayScrollPos, actionMeta));
        }
    }
    else if (!stayOnTarget) {
        dispatch(actionCreators.showHoverScreen(destinationScreenID, screenScrollPos, actionMeta));
    }
    else {
        dispatch(actionCreators.showScreen(destinationScreenID, transition, screenScrollPos, actionMeta));
    }
    if (!stayOnTarget) {
        dispatch(actionCreators.addToHoverStack({
            id: id,
            screenID: currentScreenID,
            layerID: currentOverlayID,
            scrollPos: screenScrollPos,
            maintainScroll: maintainScroll,
            coordinates: coordinates,
        }));
    }
}
function handleHotspotAction(dispatch, ownProps, stateProps, eventMeta) {
    var id = stateProps.id, type = stateProps.type, isOverlay = stateProps.isOverlay, transition = stateProps.transition, destinationScreenID = stateProps.destinationScreenID, anchorYPos = stateProps.anchorYPos, smoothScroll = stateProps.smoothScroll, currentOverlayID = stateProps.currentOverlayID, currentScreenID = stateProps.currentScreenID, maintainScroll = stateProps.maintainScroll;
    var actionMeta = __assign({ hotspotID: id, 
        // TODO do we need this now we're sampling scroll?
        screenScrollPos: getScreenScrollPos(ownProps, stateProps) }, eventMeta);
    switch (type) {
        case HotspotType.Standard: {
            if (isOverlay) {
                var overlayScrollPos = getOverlayScrollPos(ownProps, stateProps);
                dispatch(actionCreators.showOverlay(id, overlayScrollPos, actionMeta));
            }
            else if (destinationScreenID !== currentScreenID) {
                var screenScrollPos = getScreenScrollPos(ownProps, stateProps);
                dispatch(actionCreators.showScreen(destinationScreenID, transition, screenScrollPos, actionMeta));
            }
            else {
                dispatch(actionCreators.hideOverlay(transition, actionMeta));
            }
            break;
        }
        case HotspotType.Back:
            dispatch(actionCreators.historyBack(actionMeta));
            if (!maintainScroll) {
                dispatch(actionCreators.scrollTo(0, false, actionMeta));
            }
            break;
        case HotspotType.Anchor:
            if (currentOverlayID) {
                dispatch(actionCreators.setOverlayScrollPos(anchorYPos, smoothScroll, actionMeta));
            }
            else {
                dispatch(actionCreators.scrollTo(anchorYPos, smoothScroll, actionMeta));
            }
            break;
        default:
            break;
    }
}
function getOverlayScrollPos(ownProps, stateProps) {
    if ((stateProps.maintainScroll ||
        stateProps.overlayPosition === OverlayPosition.Custom) &&
        stateProps.location === screenLocation.BODY) {
        if (ownProps.getOverlayScrollPos) {
            // Hotspot is on a layer so we need the _layer_ scroll position
            // to set the next layer's scroll
            return ownProps.getOverlayScrollPos();
        }
        // Hotspot is on a screen so we need the _screen_ scroll position
        // to set the layer's scroll
        return ownProps.getScreenScrollPos();
    }
    return 0;
}
function getScreenScrollPos(ownProps, stateProps) {
    var previousScreenPos = ownProps.getScreenScrollPos();
    var scrollPos = {
        previous: previousScreenPos,
        current: 0,
    };
    if (stateProps.maintainScroll) {
        scrollPos.current = scrollPos.previous;
    }
    return scrollPos;
}
function SmartHotspot(props) {
    var action = props.action, type = props.type, hasTouch = props.hasTouch, smartContainer = props.smartContainer, formField = props.formField, width = props.width, height = props.height, inSection = props.staysInSection;
    if (!inSection) {
        return null;
    }
    // Turns out it is actually possible to create 0-width or 0-height hotspots in
    // the editor
    if (!width || !height) {
        return null;
    }
    if (type === HotspotType.Embed) {
        return React.createElement(EmbeddedHotspot, __assign({}, props));
    }
    if (type === HotspotType.Video) {
        return React.createElement(VideoHotspot, __assign({}, props));
    }
    if (smartContainer) {
        return (React.createElement(ScrollContainer, __assign({}, props, props.smartContainer.scrollable, { fixed: props.smartContainer.fixedPosition.isEnabled })));
    }
    if (formField) {
        return React.createElement(FormFieldHotspot, __assign({}, props));
    }
    if (hasTouch) {
        if (action === hotspotAction.HOVER) {
            return null;
        }
        if (hotspotAction.isTouchAction(action)) {
            return React.createElement(TouchableHotspot, __assign({}, props));
        }
    }
    if (action === hotspotAction.HOVER) {
        return React.createElement(HoverHotspot, __assign({}, props));
    }
    if (type === HotspotType.Url) {
        return React.createElement(ExternalLinkHotspot, __assign({}, props));
    }
    return React.createElement(DumbHotspot, __assign({}, props));
}
SmartHotspot.propTypes = {
    type: PropTypes.number.isRequired,
    hasTouch: PropTypes.bool.isRequired,
    action: PropTypes.string.isRequired,
};
export default compose(getContext({ isCurrentScreen: PropTypes.bool.isRequired }), connect(mapStateToProps, null, mergeProps))(SmartHotspot);
